export default "__VITE_ASSET__BRdUwY3Q__"